module.exports = __webpack_public_path__ + "static/media/postcard1.9ae148dd.jpg";